import { Outlet } from 'react-router-dom';
import AccessGate from './AccessGate';
import { Box } from '@mui/material';
import { Global, css } from '@emotion/react';

function ProtectedLayout() {
    return (
        <AccessGate>
            <Global
                styles={css`
                    body {
                        margin: 0;
                        padding: 0;
                        background: none;
                        font-family: 'Roboto', sans-serif;
                    }
                `}
            />
            <Box sx={{ p: 2 }}>
                <Outlet />
            </Box>
        </AccessGate>
    );
}

export default ProtectedLayout;